import { useState } from "react";

import VideoModal from "./VideoModal";
import { VIDEO_URL, POSTER_URL } from "./homeVideoAssets";

const HomeVideoOverviewV2 = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <section className="promo-section pt-60 pb-100 gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-5">
                <h2>Take a Look Inside NER & Our Partner Network</h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-5">
            <div className="col-lg-8">
              <div
                role="button"
                tabIndex={0}
                aria-label="Play video"
                onClick={() => setOpen(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setOpen(true);
                }}
                style={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: "56.25%",
                  height: 0,
                  borderRadius: "12px",
                  overflow: "hidden",
                  cursor: "pointer",
                  boxShadow: "0 15px 40px rgba(0, 0, 0, 0.2)",
                  background: `url('${POSTER_URL}') no-repeat center center / cover`,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    className="ti-control-play"
                    style={{
                      width: "80px",
                      height: "80px",
                      lineHeight: "80px",
                      borderRadius: "50%",
                      background: "rgba(255, 255, 255, 0.92)",
                      color: "#1a1a2e",
                      fontSize: "30px",
                      textAlign: "center",
                      display: "inline-block",
                      boxShadow: "0 4px 18px rgba(0, 0, 0, 0.35)",
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isOpen && (
        <VideoModal
          videoUrl={VIDEO_URL}
          posterUrl={POSTER_URL}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default HomeVideoOverviewV2;
